import React, { useState, useEffect, useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { useAccountSettingsContext } from "./AccountSettingsUiContext";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import axios from "axios";
import { useSnackbar } from "react-simple-snackbar";
export function AccountSettingsCard() {
  const [openSnackbarError] = useSnackbar({
    style: {
      backgroundColor: "red",
      border: "2px solid white",
      color: "white",

      fontSize: "15px",
      textAlign: "center",
    },
  });
  const [openSnackbarSuccess] = useSnackbar({
    style: {
      backgroundColor: "green",
      border: "2px solid white",
      color: "white",

      fontSize: "15px",
      textAlign: "center",
    },
  });

  function onSettingsChange(key, value) {
    setAccountSettings({ ...accountSettings, [key]: value });
  }
  const CloseOpenInvoicePolicyChanged = (event) => {
    setcloseOpenInvoicePolicy(event.target.value);
  };

  const CloseOpenInvoicePolicies = [
    {
      type: "CloseMissingInvoiceFromLastUpdate",
      name: "Close Missing Invoice From Last Update",
    },
    { type: "MissingInvoiceRemainsOpen", name: "Missing Invoice Remains Open" },
  ];
  const [accountSettings, setAccountSettings] = useState({
    name: "",
    taxId: "",

    customerDefaultPaymentGraceDays: 30,
  });
  const [closeOpenInvoicePolicy, setcloseOpenInvoicePolicy] = useState();

  const dispatch = useDispatch();

  const accountSettingsContext = useAccountSettingsContext();
  const accountSettingsProps = useMemo(() => {
    return {};
  }, [accountSettingsContext]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}account`)
      .then(function(response) {
        setAccountSettings(response.data);
        setcloseOpenInvoicePolicy(
          response.data.dataHandlingPolicy.closeOpenInvoicePolicy
        );
        //  self.setState({events: response.data})
      });

    //   .then((response) => response.data)
    //   .then(setAccountSettings);
  }, []); // Or [] if effect doesn't need props or state

  const save = () => {
    let data = accountSettings;
    data.dataHandlingPolicy = {
      closeOpenInvoicePolicy: closeOpenInvoicePolicy,
    };

    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}account`, { data })
      .then((data) => {
        openSnackbarSuccess("Saved");
      })
      .catch((error) => {
        console.log(error);
        //      openSnackbarError("error");
        //   openSnackbarError(error.response.data.error[0].msg);
        openSnackbarError(error.response.data.error.msg);
      });
  };

  return (
    <Card>
      <CardHeader title="Basic"></CardHeader>
      <CardBody>
        <div className="container">
          <form className="padding-top-0">
            <div className="row">
              <label>Account name</label>
              <input
                type="text"
                className="form-control"
                value={accountSettings.name || ""}
                placeholder="Name"
                onChange={(e) => onSettingsChange("name", e.target.value)}
              />
            </div>
            <div className="row">
              <label>Tax id</label>
              <input
                type="text"
                disabled="true"
                className="form-control"
                value={accountSettings.taxId || ""}
                placeholder="TaxId"
              />
            </div>
            <div className="row">
              <label>Close open invoice policy</label>
              <select
                className="custom-select"
                onChange={CloseOpenInvoicePolicyChanged}
                value={closeOpenInvoicePolicy}
              >
                {CloseOpenInvoicePolicies.map((policy) => (
                  <option key={policy.type} value={policy.type}>
                    {policy.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="row">
              <label>Default customer payment terms</label>
              <input
                type="number"
                step="1"
                className="form-control"
                value={accountSettings.customerDefaultPaymentGraceDays}
                placeholder="Default customer payment terms"
                onChange={(e) =>
                  onSettingsChange(
                    "customerDefaultPaymentGraceDays",
                    e.target.value
                  )
                }
              />
            </div>

            <div className="row"></div>
          </form>

          <div className="row">
            <button className="btn btn-success float-right" onClick={save}>
              Save
              <span className="svg-icon-sm svg-icon-primary ml-3">
                <SVG
                  width="15px"
                  height="15px"
                  src={toAbsoluteUrl("/media/svg/icons/General/Save.svg")}
                ></SVG>
              </span>
            </button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
